// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsDCFSA = {
  benefits_section_fsa: {
    contentful_name: '[DEFAULT] Benefits Section - DCFSA',
    federal_limit_description:
      '受抚养人护理FSA的年度缴款限额为每户{fedLimit},如果已婚并单独报税,则根据联邦限额为3,750美元。',
    custom_limit_description:
      '您每年最多可以向受抚养人护理FSA账户缴存{limit}。如果您已婚,您的配偶也可以通过其雇主向DCFSA账户存款,但两人的总金额不得超过联邦限额。',
    minimum_contribution: '此账户还要求每年至少缴纳{min}。',
    incur_submit_info:
      '您可以使用您的受抚养人护理FSA支付在{incurDate}之前产生的任何符合条件的费用。您需要在{submitDate}之前完成所有理赔申请的提交。',
    federal_limit: 7500,
  },
};
